// extracted by mini-css-extract-plugin
export var container = "_sd-0";
export var dotAnimation = "_sd-2";
export var dotsLoading = "_sd-1";